import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoriesPage from "../pages/categories/page";
import QuizDetailPage from "../pages/quiz/page";
import AboutPage from "../pages/about/page";
import WriteForUsPage from "../pages/write-for-us/page";
import PrivacyPolicyPage from "../pages/privacy/page";
import TermsOfUsePage from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/quiz/:id",
    element: <QuizDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/write-for-us",
    element: <WriteForUsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms",
    element: <TermsOfUsePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
